

import {
    ModalContent, ModalFooter, ModalHeader,
} from '../ModalView'

import Button from 'components/Button'
import {ConfirmationModalProps} from './types'
import {
    ExclamationIcon,
} from 'components/Icon'
import {Icon} from 'components/Icon/types'

import Modal from '../Modal'

import React from 'react'

import {
    useTranslation,
} from 'react-i18next'


const ConfirmationPromiseModalView = (props: ConfirmationModalProps): React.ReactElement => {
    const {
        onResolve, onReject, text, title, submitText, icon, modalProps,
    } = props
    const {t} = useTranslation()

    const onConfirm = () => {
        // eslint-disable-next-line no-unused-expressions
        onResolve && onResolve()
    }
    const handleCloseModal = () => {
        // eslint-disable-next-line no-unused-expressions
    }

    const onCancel = () => {
        // eslint-disable-next-line no-unused-expressions
        onReject && onReject(true)
    }

    return (
        <Modal onClose={handleCloseModal} zIndex={200} {...modalProps}>
            <ModalHeader icon={(icon || ExclamationIcon) as unknown as Icon} title={title} type='error' />
            <ModalContent>
                <div>{text}</div>
            </ModalContent>
            <ModalFooter>
                <Button onPress={onCancel} tabIndex={-1} text={t('Cancel')} />
                <Button color='filled' margin='left' onPress={onConfirm} tabIndex={0} text={submitText || t('OK')} />
            </ModalFooter>
        </Modal>
    )
}

export default ConfirmationPromiseModalView
